import { render } from "./editFinalTransportation.vue?vue&type=template&id=3fca339a&ts=true"
import script from "./editFinalTransportation.vue?vue&type=script&lang=ts"
export * from "./editFinalTransportation.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__